import React from "react";
import { Form, Select } from "antd";
import { Countries } from "../../../common/Countries";
import { createUseStyles } from "react-jss";
const { Option } = Select;
const UICountrySelect = ({
  style = {},
  label,
  name,
  required,
  defaultValue,
  rules,
  index,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  initialValue,
  source
}) => {
  // const onChangeCountry = ()=>{
  //   onChange();
  // }
  const styles = useStyles();

  return (
    <Form.Item
      label={
        <span style={{ fontSize: "16px", fontWeight: "500" }}>{label}</span>
      }
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue}
    >
      <Select
        showSearch
        placeholder="Select Country"
        onChange={onChange}
        className={source === "employer" ? styles.empCustomSelect : styles.customSelect}
        // style={{ padding: "12px 10px !important" , fontSize: '16px' , fontWeight: "500" , ...style , height: "50px !important" }}
        allowClear
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      >
        {Object.values(Countries)?.map((item, index) => {
          return (
            <Option key={index} value={Object.keys(Countries)[index]}>
              {item}
            </Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};

export default UICountrySelect;

const useStyles = createUseStyles({
  empCustomSelect: {
    padding: "12px",
    fontWeight: "500",
    border: "1px solid #e5e7eb",
    borderRadius: 22,
    height: 42,
    display: "flex",
    alignItems: "center",
    boxShadow: "0 12px 35px rgba(15, 23, 42, 0.04)",
  },
  customSelect: {
    height: "51px !important",
    '& .ant-select-selector': {
      height: "50px",
      fontSize: "16px",
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
    },
    '& .ant-select-selection-item': {
      fontSize: "16px",
      fontWeight: 500,
    },
    '& .ant-select-selection-placeholder': {
      fontSize: "16px",
      fontWeight: 500,
    },
  }
});
